module.exports = __webpack_public_path__ + "static/media/2_exp_incomplete.fe9342d3.png";